export const fromThirtyDays = () => {
  const today = new Date();
  return new Date().setDate(today.getDate() - 30);
};
